// extracted by mini-css-extract-plugin
export default {"logoBlock":"Logo_logoBlock__2512q","logo":"Logo_logo__T0fhF"};